<template>
  <div class="dg__link aui-inline">
    <span v-if="value || href" @click="openFileType" class="link cursor-pointer t-[theme]" target="_blank">
      <slot></slot>
    </span>
    <span v-else>-</span>
  </div>
</template>

<script>
import mixin from "@/assets/js/mixin";

export default {
  mixins: [mixin],
  name: "dg-link",
  props: {
    value: String,
    href: String
  },
  methods:{
    openFileType(){
      if(this.value){
        this.downloadFile(this.value,'download')
      }else{
        this.downloadFile(this.href)
      }
      
    }
  }
};
</script>


<style scoped lang="less">
.dg__link {
  width: 120px;

  a {
    color: #407BF5;
  }
}
</style>
